var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 201,
    viewBox: "0 0 161 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650391,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.444 179.65C25.652 179.65 26.884 178.53 26.884 176.69C26.884 175.282 25.988 174.29 24.164 174.082V173.97C25.796 173.778 26.5 172.834 26.5 171.57C26.5 169.874 25.268 168.93 23.22 168.93H17.22V179.65H23.444ZM18.932 170.482H23.028C24.228 170.482 24.788 170.946 24.788 171.954C24.788 172.962 24.18 173.426 22.98 173.426H18.932V170.482ZM18.932 174.85H23.252C24.516 174.85 25.156 175.33 25.156 176.45C25.156 177.618 24.532 178.098 23.252 178.098H18.932V174.85ZM30.3391 179.81C32.1471 179.81 33.4111 179.01 33.8271 177.666H33.9391V179.65H35.5231V174.818C35.5231 172.914 34.3871 171.538 31.8591 171.538C29.3311 171.538 27.8271 172.898 27.8271 174.706V174.77H29.5391V174.706C29.5391 173.538 30.2591 173.058 31.7311 173.058C33.2511 173.058 33.8271 173.522 33.8271 174.834V175.298L30.2111 175.682C28.6431 175.858 27.6511 176.498 27.6511 177.73C27.6511 179.042 28.6911 179.81 30.3391 179.81ZM29.3791 177.618C29.3791 176.994 29.8111 176.786 30.7071 176.674L33.8271 176.322C33.8271 177.89 32.6111 178.562 30.8031 178.562C29.8111 178.562 29.3791 178.258 29.3791 177.618ZM38.7936 179.65V168.93H37.0656V179.65H38.7936ZM42.7298 179.81C44.5378 179.81 45.8018 179.01 46.2178 177.666H46.3298V179.65H47.9138V174.818C47.9138 172.914 46.7778 171.538 44.2498 171.538C41.7218 171.538 40.2178 172.898 40.2178 174.706V174.77H41.9298V174.706C41.9298 173.538 42.6498 173.058 44.1218 173.058C45.6418 173.058 46.2178 173.522 46.2178 174.834V175.298L42.6018 175.682C41.0338 175.858 40.0418 176.498 40.0418 177.73C40.0418 179.042 41.0818 179.81 42.7298 179.81ZM41.7698 177.618C41.7698 176.994 42.2018 176.786 43.0978 176.674L46.2178 176.322C46.2178 177.89 45.0018 178.562 43.1938 178.562C42.2018 178.562 41.7698 178.258 41.7698 177.618ZM51.1843 179.65V175.714C51.1843 173.986 51.9683 173.09 53.7123 173.09C55.3603 173.09 56.0323 173.842 56.0323 175.33V179.65H57.7603V174.866C57.7603 173.026 56.6723 171.538 54.4643 171.538C52.4483 171.538 51.3923 172.818 51.1523 174.162H51.0403V171.698H49.4563V179.65H51.1843ZM63.316 179.81C65.7 179.81 67.444 178.466 67.444 176.482V176.306H65.732V176.418C65.732 177.65 64.836 178.258 63.284 178.258C61.492 178.258 60.692 177.394 60.692 175.682C60.692 173.938 61.492 173.09 63.284 173.09C64.836 173.09 65.732 173.698 65.732 174.93V175.026H67.444V174.866C67.444 172.882 65.7 171.538 63.316 171.538C60.692 171.538 58.98 173.202 58.98 175.682C58.98 178.13 60.692 179.81 63.316 179.81ZM72.7219 179.81C75.0899 179.81 76.7539 178.642 76.7539 176.946V176.802H75.0259V176.93C75.0259 177.874 74.3379 178.418 72.6739 178.418C70.8339 178.418 70.0819 177.602 70.0179 176.066H76.7699C76.8179 175.826 76.8339 175.602 76.8339 175.314C76.8339 172.898 75.1539 171.538 72.6899 171.538C70.0979 171.538 68.4019 173.202 68.4019 175.682C68.4019 178.338 70.1139 179.81 72.7219 179.81ZM72.6579 172.898C74.3539 172.898 75.2019 173.602 75.2019 175.074V175.106H70.0339C70.1299 173.682 70.8979 172.898 72.6579 172.898ZM84.8625 179.81C87.2305 179.81 88.8945 178.642 88.8945 176.946V176.802H87.1665V176.93C87.1665 177.874 86.4785 178.418 84.8145 178.418C82.9745 178.418 82.2225 177.602 82.1585 176.066H88.9105C88.9585 175.826 88.9745 175.602 88.9745 175.314C88.9745 172.898 87.2945 171.538 84.8305 171.538C82.2385 171.538 80.5425 173.202 80.5425 175.682C80.5425 178.338 82.2545 179.81 84.8625 179.81ZM84.7985 172.898C86.4945 172.898 87.3425 173.602 87.3425 175.074V175.106H82.1745C82.2705 173.682 83.0385 172.898 84.7985 172.898ZM91.9968 179.65V175.714C91.9968 173.986 92.7808 173.09 94.5248 173.09C96.1728 173.09 96.8448 173.842 96.8448 175.33V179.65H98.5728V174.866C98.5728 173.026 97.4848 171.538 95.2768 171.538C93.2608 171.538 92.2048 172.818 91.9648 174.162H91.8528V171.698H90.2688V179.65H91.9968ZM103.553 179.81C105.345 179.81 106.497 178.866 106.833 177.41H106.881V182.37H108.609V171.698H107.025V173.906H106.881C106.561 172.434 105.441 171.538 103.569 171.538C101.105 171.538 99.7125 173.218 99.7125 175.682C99.7125 178.146 101.089 179.81 103.553 179.81ZM101.457 175.682C101.457 173.762 102.449 173.122 104.113 173.122C105.889 173.122 106.881 173.954 106.881 175.666V175.81C106.881 177.442 105.841 178.242 104.145 178.242C102.433 178.242 101.457 177.586 101.457 175.682ZM113.518 179.81C115.566 179.81 116.622 178.53 116.878 177.186H116.974V179.65H118.558V171.698H116.846V175.634C116.846 177.362 116.03 178.258 114.27 178.258C112.59 178.258 111.902 177.506 111.902 176.018V171.698H110.19V176.482C110.19 178.322 111.278 179.81 113.518 179.81ZM121.856 170.77V168.93H120.128V170.77H121.856ZM121.856 179.65V171.698H120.128V179.65H121.856ZM125.184 179.65V175.186C125.184 173.762 125.744 173.01 127.104 173.01C128.288 173.01 128.768 173.538 128.768 174.674V175.378H130.48V174.338C130.48 172.834 129.696 171.538 127.888 171.538C126.256 171.538 125.392 172.562 125.152 173.842H125.04V171.698H123.456V179.65H125.184ZM132.846 182.37C134.478 182.37 135.374 181.938 136.03 180.514L140.174 171.698H138.27L136.398 175.906L135.646 177.826H135.518L134.734 175.922L132.702 171.698H130.766L134.686 179.65L134.494 180.066C134.254 180.61 133.966 180.802 133.262 180.802H131.71V182.37H132.846Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.8237,
    y1: 131.118,
    x2: 28.8237,
    y2: -10.3968,
    stroke: "url(#paint0_linear_51_1924)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.8237,
    y1: 131.118,
    x2: 64.8237,
    y2: -10.3968,
    stroke: "url(#paint1_linear_51_1924)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.824,
    y1: 131.118,
    x2: 100.824,
    y2: -10.3968,
    stroke: "url(#paint2_linear_51_1924)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.824,
    y1: 131.118,
    x2: 135.824,
    y2: -10.3968,
    stroke: "url(#paint3_linear_51_1924)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 29.9792,
    x2: 198.245,
    y2: 29.9792,
    stroke: "url(#paint4_linear_51_1924)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 88.9792,
    x2: 198.245,
    y2: 88.9792,
    stroke: "url(#paint5_linear_51_1924)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 58.9792,
    x2: 198.245,
    y2: 58.9792,
    stroke: "url(#paint6_linear_51_1924)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1504,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_51_1924)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_51_1924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1514 63.1343C36.1514 62.3823 36.761 61.7726 37.5131 61.7726H62.0247C62.7768 61.7726 63.3865 62.3823 63.3865 63.1343C63.3865 63.8864 62.7768 64.4961 62.0247 64.4961H37.5131C36.761 64.4961 36.1514 63.8864 36.1514 63.1343ZM38.8749 52.2403C38.8749 51.4882 39.4846 50.8785 40.2366 50.8785C40.9887 50.8785 41.5984 51.4882 41.5984 52.2403V59.0491C41.5984 59.8012 40.9887 60.4108 40.2366 60.4108C39.4846 60.4108 38.8749 59.8012 38.8749 59.0491V52.2403ZM45.6837 52.2403C45.6837 51.4882 46.2933 50.8785 47.0454 50.8785C47.7975 50.8785 48.4072 51.4882 48.4072 52.2403V59.0491C48.4072 59.8012 47.7975 60.4108 47.0454 60.4108C46.2933 60.4108 45.6837 59.8012 45.6837 59.0491V52.2403ZM51.1307 52.2403C51.1307 51.4882 51.7404 50.8785 52.4924 50.8785C53.2445 50.8785 53.8542 51.4882 53.8542 52.2403V59.0491C53.8542 59.8012 53.2445 60.4108 52.4924 60.4108C51.7404 60.4108 51.1307 59.8012 51.1307 59.0491V52.2403ZM57.9395 52.2403C57.9395 51.4882 58.5491 50.8785 59.3012 50.8785C60.0533 50.8785 60.663 51.4882 60.663 52.2403V59.0491C60.663 59.8012 60.0533 60.4108 59.3012 60.4108C58.5491 60.4108 57.9395 59.8012 57.9395 59.0491V52.2403ZM36.1514 45.566C36.1514 44.649 36.6694 43.8107 37.4896 43.4006L48.6863 37.8023C49.3678 37.4615 50.17 37.4615 50.8516 37.8023L62.0482 43.4006C62.8684 43.8107 63.3865 44.649 63.3865 45.566V47.0959C63.3865 48.4329 62.3026 49.5168 60.9656 49.5168H38.5723C37.2352 49.5168 36.1514 48.4329 36.1514 47.0959V45.566ZM49.7689 45.4315C50.1301 45.4315 50.4765 45.2881 50.7318 45.0327C50.9872 44.7773 51.1307 44.4309 51.1307 44.0698C51.1307 43.7086 50.9872 43.3622 50.7318 43.1069C50.4765 42.8515 50.1301 42.708 49.7689 42.708C49.4078 42.708 49.0614 42.8515 48.806 43.1069C48.5506 43.3622 48.4072 43.7086 48.4072 44.0698C48.4072 44.4309 48.5506 44.7773 48.806 45.0327C49.0614 45.2881 49.4078 45.4315 49.7689 45.4315Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0047 53.6045C56.7548 53.6045 55.7427 54.6179 55.7427 55.8665V67.4771C55.7427 68.726 56.7558 69.7391 58.0047 69.7391H66.5864C67.8353 69.7391 68.8484 68.726 68.8484 67.4771V62.1766C68.8484 61.242 68.4772 60.3456 67.8163 59.6847C67.1554 59.0239 66.259 58.6526 65.3244 58.6526H64.0624C63.9929 58.6526 63.9262 58.625 63.8771 58.5758C63.828 58.5267 63.8004 58.46 63.8004 58.3906V57.1285C63.8004 56.1939 63.4291 55.2975 62.7682 54.6367C62.1073 53.9758 61.211 53.6045 60.2763 53.6045H58.0047Z",
    fill: "#C1D6FF",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1504,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_51_1924)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1924",
    x1: 29.3237,
    y1: 9.68107,
    x2: 29.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1924",
    x1: 65.3237,
    y1: 9.68107,
    x2: 65.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1924",
    x1: 101.324,
    y1: 9.68107,
    x2: 101.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1924",
    x1: 136.324,
    y1: 9.68107,
    x2: 136.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1924",
    x1: -60.1421,
    y1: 30.4792,
    x2: 195.012,
    y2: 30.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1924",
    x1: -60.1421,
    y1: 89.4792,
    x2: 195.012,
    y2: 89.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1924",
    x1: -60.1421,
    y1: 59.4792,
    x2: 195.012,
    y2: 59.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_1924",
    x1: 52.5,
    y1: 16.6504,
    x2: 52.5,
    y2: 88.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_1924",
    x1: 52.5,
    y1: 16.6504,
    x2: 52.5,
    y2: 88.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1924"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650391,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_51_1924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(31 32)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact8);
export default __webpack_public_path__ + "static/media/contact8.5e3874802b1a0459ef0039d0d6533333.svg";
export { ForwardRef as ReactComponent };